<script lang="ts">
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'DisplayMoney',
  props: {
    currency: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
  },
  setup() {
    const { t } = useI18n()

    return {
      t,
    }
  },
})
</script>

<template>
  <div dir="ltr"><I18nN v-if="amount" :value="amount" format="price" /> {{ currency }}</div>
</template>
